var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAgent = function SvgAgent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3343 8.33341C12.1753 8.33341 13.6676 6.84103 13.6676 5.00008C13.6676 3.15913 12.1753 1.66675 10.3343 1.66675C8.49336 1.66675 7.00098 3.15913 7.00098 5.00008C7.00098 6.84103 8.49336 8.33341 10.3343 8.33341Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.834 18.3335C17.834 14.1914 14.4761 10.8335 10.334 10.8335C6.1919 10.8335 2.83398 14.1914 2.83398 18.3335",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3337 18.3335L12.0003 16.2502L10.3337 10.8335L8.66699 16.2502L10.3337 18.3335Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgAgent;